/**
 * Appium에서 accessibilityIdentifier에 띄어쓰기가 들어가면 인식이 잘 안되는 문제가 있어 띄어쓰기 미사용
 * iOS Accessibility.swift와 동일한 query-string 인코딩 패턴
 *
 * @see Linear ENABLE-221
 */

const createQueryString = (
  items: Record<string, string | number | undefined | null>,
): string => {
  const params = Object.entries(items)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return params;
};

export const Accessibility = {
  Common: {
    backButton: '뒤로가기버튼',
    clearSearchKeywordButton: '검색어삭제버튼',
    searchField: '검색필드',
  },
  Search: {
    /** 검색바 우측 카메라+"검색" 버튼 (이미지 검색 진입) */
    imageSearchButton: '검색',
    /** 최근검색어 리스트 항목 */
    recentKeywordListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `최근검색어리스트?${queryString}`;
    },
    /** 인기 뷰티 카테고리 리스트 항목 (구 추천검색어리스트) */
    beautyCategoryListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `인기뷰티카테고리리스트?${queryString}`;
    },
    /** 인기 검색어 연령 필터 */
    ageFilter: (value: string): string => {
      const queryString = createQueryString({
        TITLE: value,
      });
      return `인기검색어연령필터?${queryString}`;
    },
    /** 인기검색어 리스트 항목 */
    popularKeywordListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `인기검색어리스트?${queryString}`;
    },
    /** 자동완성 영역의 카테고리 버튼 */
    suggestCategoryButton: '카테고리',
    /** 자동완성 영역의 마켓 버튼 */
    suggestMarketButton: '마켓',
    /** 자동완성 영역의 기획전 버튼 */
    suggestPlanButton: '기획전',
  },
  Result: {
    /** 검색결과 화면의 상단 검색바 (탭하면 SearchHelper 복귀) */
    searchButton: '검색',
  },
} as const;
